import { Outlet } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function MainHead() {

    return <HelmetProvider>
        <Helmet>
            <meta charSet="utf-8" />
            <title>IOST blockchain mainnet</title>

            <meta name="viewport" content="width=device-width, initial-scale=0.86, maximum-scale=0.86, user-scalable=0" />
            <meta name="description" content="IOST3.0 is launching as a BNBChain L2 | Welcome to the IOST blockchain mainnet" />

            <link rel="apple-touch-icon" sizes="180x180" href="/img/apple-touch-icon.png" />
            <link rel="icon" type="image/png" sizes="32x32" href="/img/favicon-32x32.png" />
            <link rel="icon" type="image/png" sizes="16x16" href="/img/favicon-16x16.png" />
            <link rel="icon" href="/img/favicon/favicon.png" />
            <meta property="og:image" content="/img/preview.png" />

            <link href="/assets/user.css" rel="stylesheet" />
        </Helmet>

        <Outlet />

    </HelmetProvider >
}